const faqItems = [
  {
    q: '51吃瓜视频是什么平台？',
    a: '51吃瓜视频是一个专注于热门八卦、娱乐爆料与社会热点视频的在线观看平台，汇集全网最新吃瓜资源，支持高清免费播放，每日实时更新。',
  },
  {
    q: '观看视频需要注册或付费吗？',
    a: '不需要。51吃瓜视频所有内容均免费开放，无需注册、无需登录，打开即看，即点即播，完全零门槛体验。',
  },
  {
    q: '视频画质怎么样？支持高清播放吗？',
    a: '平台所有视频均支持1080P高清画质播放，自动适配网络带宽，确保流畅不卡顿，为你带来最佳的吃瓜观看体验。',
  },
  {
    q: '平台每天更新多少内容？',
    a: '我们每天从全网50余个优质内容源采集更新200余条最新吃瓜视频，涵盖娱乐圈八卦、网红动态、社会热点等多个分类。',
  },
  {
    q: '如何在手机上看51吃瓜视频？',
    a: '手机浏览器直接访问即可，页面已全面适配移动端。也可关注我们的官方社交媒体账号获取每日精选推送。',
  },
  {
    q: '内容来源可靠吗？会不会有虚假信息？',
    a: '平台内容均来自全网公开渠道，我们致力于聚合与展示，不对原始内容做二次加工。建议用户理性吃瓜，多方核实信息。',
  },
];

const topics = [
  { name: '娱乐圈八卦', hot: true, count: '3.2万' },
  { name: '网红爆料', hot: true, count: '2.8万' },
  { name: '社会热点', hot: true, count: '5.1万' },
  { name: '明星动态', hot: false, count: '1.9万' },
  { name: '综艺名场面', hot: true, count: '4.3万' },
  { name: '影视剧透', hot: false, count: '1.5万' },
  { name: '吃瓜二创', hot: false, count: '8,620' },
  { name: '情感八卦', hot: true, count: '2.1万' },
  { name: '直播名场面', hot: false, count: '1.2万' },
  { name: '体育趣闻', hot: false, count: '9,350' },
  { name: '科技圈瓜', hot: true, count: '1.7万' },
];

export function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-lg overflow-hidden">
          <div className="flex flex-col md:flex-row items-center gap-6 p-6 md:p-10">
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-xl md:text-2xl font-bold text-white">随时随地，畅快吃瓜</h2>
              <p className="mt-2 text-sm md:text-base text-white/80">
                手机浏览器直接访问，无需下载APP。页面已全面适配移动端，高清流畅播放，走到哪吃到哪。
              </p>
              <div className="mt-4 flex flex-wrap items-center justify-center md:justify-start gap-3">
                <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-white/20 backdrop-blur rounded-full text-white text-sm font-medium whitespace-nowrap cursor-pointer">
                  <i className="ri-smartphone-line"></i>
                  手机端访问
                </span>
                <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-white/20 backdrop-blur rounded-full text-white text-sm font-medium whitespace-nowrap cursor-pointer">
                  <i className="ri-qr-code-line"></i>
                  扫码直达
                </span>
              </div>
            </div>
            <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 bg-white/15 rounded-lg flex items-center justify-center">
              <i className="ri-smartphone-line text-3xl md:text-4xl text-white"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  return (
    <section id="faq" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">吃瓜问答</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">关于51吃瓜视频，你想知道的都在这里</p>
        <div className="mt-6 md:mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/60 rounded-lg p-4 md:p-5"
            >
              <h3 className="flex items-start gap-2 text-sm md:text-base font-bold text-foreground-900">
                <span className="text-primary-500 shrink-0 mt-0.5">Q</span>
                {item.q}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed pl-5">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">关于我们</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">了解51吃瓜视频</p>
        <div className="mt-6 md:mt-8 max-w-3xl mx-auto text-center">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            51吃瓜视频成立于2024年，是国内领先的吃瓜视频聚合平台。我们致力于为广大吃瓜爱好者提供一站式的视频观看体验，涵盖娱乐圈八卦、网红爆料、社会热点等全品类内容。平台以&ldquo;高清、免费、实时&rdquo;为核心特色，每日从全网50余个优质内容源精选200余条最新视频，确保用户第一时间获取最热吃瓜动态。无论你是资深瓜友还是偶尔吃瓜，51吃瓜视频都能满足你对八卦资讯的所有想象。
          </p>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-4 md:gap-8">
            <div className="text-center">
              <div className="text-lg md:text-xl font-black text-accent-500">2024</div>
              <div className="text-xs text-foreground-500">成立年份</div>
            </div>
            <div className="text-center">
              <div className="text-lg md:text-xl font-black text-accent-500">500万+</div>
              <div className="text-xs text-foreground-500">月活用户</div>
            </div>
            <div className="text-center">
              <div className="text-lg md:text-xl font-black text-accent-500">10万+</div>
              <div className="text-xs text-foreground-500">视频资源</div>
            </div>
            <div className="text-center">
              <div className="text-lg md:text-xl font-black text-accent-500">50+</div>
              <div className="text-xs text-foreground-500">内容来源</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">联系我们</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">投稿、合作、意见反馈</p>
        <div className="mt-6 md:mt-8 max-w-lg mx-auto">
          <div className="bg-background-50 border border-background-200/60 rounded-lg p-5 md:p-6">
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-primary-500"></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-800">投稿邮箱</div>
                  <div className="text-xs text-foreground-500">tougao@51chigua.com</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                  <i className="ri-wechat-line text-accent-500"></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-800">官方微信</div>
                  <div className="text-xs text-foreground-500">51chigua_official</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center shrink-0">
                  <i className="ri-global-line text-secondary-500"></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-800">商务合作</div>
                  <div className="text-xs text-foreground-500">bd@51chigua.com</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">热门话题</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">大家都在搜的吃瓜热点</p>
        <div className="mt-6 md:mt-8 flex flex-wrap justify-center gap-2 md:gap-3 max-w-4xl mx-auto">
          {topics.map((t) => (
            <a
              key={t.name}
              href="#carousel"
              className={`inline-flex items-center gap-1.5 px-3 py-2 md:px-4 md:py-2.5 rounded-full text-xs md:text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-200 text-foreground-600 hover:bg-background-300'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-xs"></i>}
              {t.name}
              <span className={`text-[10px] md:text-xs ${t.hot ? 'text-primary-400' : 'text-foreground-400'}`}>
                {t.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}